import { RequestArticleContextData } from '@/routes/Requests/contexts/interfaces';

export const computeStartArticleRepairContext = ({
  view,
}: {
  view: RequestArticleContextData['view'];
}) => {
  view.services.actions.fields.spareParts.referenceNumber.editable = true;
  view.services.actions.fields.spareParts.quantity.editable = true;
  view.services.actions.fields.spareParts.canAddRemoveSparePart = true;
};
